import { Validation } from '@shared/lib/utils';

const onLoginFormValid = (formData) => {
  let errorsState = {};

  const validationEmail = new Validation({
    field: formData.email,
    title: 'Email',
  })
    .isRequired()
    .isEmail()
    .maxLenght(64)
    .getErrors();

  const validationPassword = new Validation({
    field: formData.password,
    title: 'Password',
  })
    .isRequired()
    .minLenght(8)
    .maxLenght(32)
    .getErrors();

  if (validationEmail.length) {
    errorsState = {
      ...errorsState,
      email: validationEmail[0],
    };
  }

  if (validationPassword.length) {
    errorsState = {
      ...errorsState,
      password: validationPassword[0],
    };
  }

  return errorsState;
};

export default onLoginFormValid;
